import React from 'react';
import ArrayMap from '../../../../lib/ArrayMap/ArrayMap';
import BoxSelect from '../../../../lib/BoxSelect/BoxSelect';

interface IOfferedOptionsProps {
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
}

const OfferedOptions: React.FC<React.PropsWithChildren<React.PropsWithChildren<IOfferedOptionsProps>>> = ({
  name = 'offeredOption',
  value,
  onChange,
}) => {
  const options = [
    {
      title: 'Accept the new spot',
      subTitle: 'Your booking will be transferred to the new appointment spot',
      value: 'accept',
    },
    {
      title: 'Request a different date / time',
      subTitle: 'Propose a different appointment spot',
      value: 'requestNew',
    },
    {
      title: 'Keep the original booking',
      subTitle: `Your appointment can stay with the existing appointment spot you've booked`,
      value: 'keepOriginal',
    },
    {
      title: 'Cancel the booking',
      subTitle: `Cancel the booking with this stylist. You can get a credit for the deposit paid.`,
      value: 'cancelBooking',
    },
  ];

  function handleChange(e) {
    const { value } = e.target;
    onChange?.({
      target: { name, value },
    });
  }
  return (
    <div className="grid gap-4 px-2 pb-8">
      <ArrayMap items={options}>
        {({ title, subTitle, value: optionValue }) => (
          <BoxSelect
            titleClassName="lg:text-white"
            subTitleClassName="lg:text-gray-300"
            title={title}
            subTitle={subTitle}
            value={optionValue}
            checked={value === optionValue}
            onChange={handleChange}
            checkboxType="radio"
          />
        )}
      </ArrayMap>
    </div>
  );
};
export default OfferedOptions;
